// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editorClassName {
  border: 1px solid #F1F1F1 !important;
  padding: 5px !important;
  border-radius: 2px !important;
  height: 80% !important;
  min-height: 150px;
  max-height: 300px;
  overflow-y: auto;
}

.rdw-editor-wrapper {
  position: relative;
  z-index: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/overrides/markdown.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":[".editorClassName {\n  border: 1px solid #F1F1F1 !important;\n  padding: 5px !important;\n  border-radius: 2px !important;\n  height: 80% !important;\n  min-height: 150px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.rdw-editor-wrapper {\n  position: relative;\n  z-index: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
